(ns app.front.acceptance.subs
  (:require [app.domain.acceptance.model :as acceptance-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [core.db.entity.util :as eu]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::acceptances
  :<- [::entities/entity-db]
  (fn [entity-db [_ parent-id]]
    (->> entity-db
         vals
         (filter (p/where-fn {:entity/type   :entity.type/acceptance
                              :entity/parent parent-id})))))

(rf/reg-sub ::entity-latest-acceptance
  (fn [[_ parent-id] _]
    (rf/subscribe [::acceptances parent-id]))
  :-> du/latest-entity)

(rf/reg-sub ::entity-pending-acceptances
  (fn [[_ parent-id] _]
    (rf/subscribe [::acceptances parent-id]))
  (fn [acceptances _]
    (->> acceptances
         (filter (some-fn acceptance-model/acceptance-can-be-responded-to?
                          (du/in-state-fn :acceptance.state/draft)))
         ;; always include latest, things may have been OKd without applicant response
         (concat [(du/latest-entity acceptances)])
         (remove nil?)
         distinct
         (sort-by :entity/created)
         seq)))

(rf/reg-sub ::entity-respondable-acceptances
  (fn [[_ parent-id] _]
    (rf/subscribe [::acceptances parent-id]))
  (fn [acceptances _]
    (->> acceptances
         (filter acceptance-model/acceptance-can-be-responded-to?)
         du/entity-id-set
         not-empty)))



(rf/reg-sub ::acceptance-data-from-newest-to-oldest
  (fn [[_ parent-id] _]
    (rf/subscribe [::acceptances parent-id]))
  (fn [acceptances _]
    (->> acceptances
         (sort-by :entity/created)
         reverse)))

(rf/reg-sub ::draft-acceptance
  (fn [[_ _ parent-id] _]
    (rf/subscribe [::entities/entities {:entity/type   :entity.type/acceptance
                                        :domain/state  :acceptance.state/draft
                                        :entity/parent parent-id}]))
  (fn [drafts [_ review-id _]]
    (->> drafts
         (filter #(-> % :review/_acceptances du/entity-id-set (contains? review-id)))
         eu/latest)))

(defn draft-acceptance-sig [[_ review-id parent-id] _]
  (rf/subscribe [::draft-acceptance review-id parent-id]))

(rf/reg-sub ::draft-value
  draft-acceptance-sig
  :-> :acceptance/value)

(rf/reg-sub ::draft-comment
  draft-acceptance-sig
  :-> :acceptance/text)

(rf/reg-sub ::draft-id
  draft-acceptance-sig
  :-> :db/id)
